import { render, staticRenderFns } from "./RecipientForm.vue?vue&type=template&id=af336454&scoped=true&"
import script from "./RecipientForm.vue?vue&type=script&lang=js&"
export * from "./RecipientForm.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=af336454&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af336454",
  null
  
)

export default component.exports